<div class="container">
  <h2>Details bearbeiten</h2>
  <div class="item-form-container">

    <form [formGroup]="itemForm" (ngSubmit)="onSubmit()">

      <div class="form-field">
        <mat-form-field>
          <mat-label>Artikelnummer:</mat-label>
          <input matInput type="text" formControlName="itemNo" />
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field>
          <mat-label>Bezeichnung:</mat-label>
          <input matInput type="text" formControlName="name" />
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field>
          <mat-label>Preis:</mat-label>
          <input matInput type="text" formControlName="price" />
        </mat-form-field>
      </div>

      <!-- <div class="form-field">
        <mat-form-field>
          <mat-label>Kategorie:</mat-label>
          <input matInput type="text" formControlName="categoryIdentifier" />
        </mat-form-field>
      </div> -->

      <div class="form-field">
        <mat-form-field>
          <mat-label>Kategorie auswählen</mat-label>
          <mat-select formControlName="categoryIdentifier">
            <mat-option *ngFor="let cat of categories" [value]="cat.identifier">{{cat.text}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field>
          <mat-label>Druckkategorie auswählen</mat-label>
          <mat-select formControlName="printCategoryIdentifier">
            <mat-option *ngFor="let cat of printCategories" [value]="cat.printCategory">{{cat.printCategory}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field>
          <mat-label>Sortierungsnummer:</mat-label>
          <input matInput type="number" formControlName="sortId" />
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field>
          <mat-label>Restmenge:</mat-label>
          <input matInput type="number" formControlName="remainingQuantity"/>
        </mat-form-field>
        <mat-checkbox formControlName="infiniteQuantity">Unendliche Menge</mat-checkbox>
      </div>

      <div class="form-field">
        <mat-checkbox formControlName="enabled">Aktiv</mat-checkbox>
      </div>

      <div class="form-field">
        <button mat-raised-button color="accent" type="submit" [disabled]="itemForm.invalid">Speichern</button>
      </div>

    </form>
  </div>
  <mat-dialog-actions align="end">
<!--    <button mat-button [mat-dialog-close]="comment" cdkFocusInitial>Ok</button>-->
    <button mat-button mat-dialog-close>Abbrechen</button>
  </mat-dialog-actions>
</div>
